import {connect} from 'react-redux';
import SubscriptionGreeting from '../components/subscriptions/SubscriptionGreeting';
import { getSubscriptionGreetingFromLocalStorage, doHideSubscriptionGreeting } from '../actions/subscriptions';
import { doNavigateToProduct } from '../actions/products';

const mapStateToProps = ({subscriptionsById}, {subscription}) => {
  return {
    subscription,
    open: subscription && subscription.greeting,
  };
};

const mapDispatchToProps = (dispatch, {subscription}) => {
  const product = subscription && subscription.plan && subscription.plan.product;
  return {
    loadData: () => {
      subscription && dispatch( getSubscriptionGreetingFromLocalStorage(subscription.id) );
    },
    handleClose: () => {
      subscription && dispatch( doHideSubscriptionGreeting(subscription.id) );
    },
    handleGetStarted: () => {
      dispatch( doHideSubscriptionGreeting(subscription) );
      // FIXME should dispatch
      product && doNavigateToProduct(product);
    }
  };
}; 

export default connect(
  mapStateToProps,
  mapDispatchToProps
) ( SubscriptionGreeting );


// WEBPACK FOOTER //
// ./src/containers/SubscriptionGreeting.js